import { Link, useNavigate } from "react-router-dom";
import { PhoneCall } from "lucide-react";

import { trustedText } from "@/lib/v3Plans";
import { ConnectionError } from "../components/ConnectionError";
import { V3Title, V3Columns, V3Actions, V3_PRIMARY, V3_SECONDARY } from "../components/v3";
import { AreaCard, ResponsibleCard } from "../components/v3app";
import { useTrusted, CheckRow, CheckList, Blocked } from "../components/v3plans";

export const EmergencyNote = ({ testid = "safety-emergency" }) => (
  <p className="mt-[18px] flex gap-[8px] text-[13px] leading-[19px] text-v3-muted" data-testid={testid}>
    <PhoneCall className="mt-[2px] h-[14px] w-[14px] shrink-0" aria-hidden="true" />Kein Notruf- und kein Überwachungsdienst. Im Notfall wähle 112 (Schweiz zusätzlich 144 Sanität, 117 Polizei).
  </p>
);

// M24: GET /member/trusted-contacts (proposed, D-84); without it the contact row says "Noch nicht verfügbar" and nothing is shared.
export default function Safety() {
  const navigate = useNavigate();
  const res = useTrusted();
  const missing = res.error === "notfound";
  const list = missing ? null : res.data?.list;
  const loading = !res.data && !res.error;
  const summary = loading ? "Wird geladen …" : res.data && list === null ? "Nicht lesbar" : trustedText(list);
  const back = () => (window.history.length > 1 ? navigate(-1) : navigate("/plaene"));
  return (
    <div data-m="M24" data-testid="safety-page">
      <V3Title title="Sicherheit und vertraute Kontakte" intro="Teile ausgewählte Treffendaten freiwillig mit einer vertrauten Person." testid="safety-title" />
      <V3Columns layout="detail" aside={<><AreaCard text={summary} testid="safety-area" /><ResponsibleCard /></>} main={res.error && !missing ? <ConnectionError onRetry={res.reload} /> : (<>
        <CheckList>
          <CheckRow title="Vertrauter Kontakt" value={summary} checked={(list || []).some((t) => t.state === "confirmed")} testid="safety-trusted" />
          <CheckRow title="Geteilte Daten" value="Nur die von dir gewählten Treffendaten" testid="safety-shared" />
          <CheckRow title="Rückmeldung" value="Freiwillig nach dem Treffen" to="/sicherheit/rueckmeldung" testid="safety-checkin" />
          <CheckRow title="Live-Ortung" value="Nicht Bestandteil dieser Funktion" testid="safety-location" />
        </CheckList>
        {missing && <Blocked id="safety-trusted-unavailable">Vertraute Kontakte sind im gemeinsamen Core noch nicht eingerichtet. Es wird nichts geteilt und niemand benachrichtigt.</Blocked>}
        <V3Actions>
          <Link to="/sicherheit/vertraute-kontakte" data-testid="safety-invite" className={V3_PRIMARY}>Vertrauten Kontakt einladen</Link>
          <button type="button" onClick={back} data-testid="safety-back" className={V3_SECONDARY}>Zurück</button>
        </V3Actions>
        <EmergencyNote />
      </>)} />
    </div>
  );
}
